<template>
  <v-dialog v-model="openComponente" persistent width="800px" content-class="">
    <v-card>

      <!-- cabecera del dialogo -->

      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ informeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ informeComponente.descripcion }}
          </v-flex>

          <!-- representantes -->
          <v-layout row wrap v-if="dRole !== 'CLIENTE'">
            <v-flex xs12 sm12 px-3>
              <p class="datLabelGroup pt-0">
                {{ $t('representante') }}
              </p>
              <DatTextFieldCodeSubfield ref="TableRepre" :pDataPass="dDataRepre" @select="fSelectRepre" @alert="fAlert"
                @clean="fCleanRepre"></DatTextFieldCodeSubfield>
            </v-flex>
            <v-flex v-if="dRole !== 'CLIENTE'" xs12 sm12 px-3>
              <p class="datLabelGroup pt-0">
                {{ $t('cliente') }}
              </p>
              <DatTextFieldCode ref="TableClient" :pDataPass="dDataClient" @alert="fAlert" @select="fSelectClient"
                @clean="fCleanClient"></DatTextFieldCode>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 px-3>
              <p class="datLabelGroup pt-0">
                {{ $t('fecha') }}
              </p>
            </v-flex>
            <v-flex xs12 sm6 px-3>
              <v-menu ref="fechaIniVencMenu" lazy :close-on-content-click="false"
                v-model="dDatosFechas.fechaIniVencMenu" transition="scale-transition" offset-y full-width
                :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="$t('mesEjercicioInicial')"
                  v-model="dDatosFechas.fechaIniVencDateString" :rules="[rules.checkfechasVencimientos]"
                  append-icon="event" readonly></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinIni" clearable color="datSecondary"
                  v-model="dDatosFechas.fechaIniVencDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIniVencMenu.save(dDatosFechas.fechaIniVencDate)" type="month">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 px-3>
              <v-menu ref="fechaFinVencMenu" lazy :close-on-content-click="false"
                v-model="dDatosFechas.fechaFinVencMenu" transition="scale-transition" offset-y full-width
                :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="$t('mesEjercicioFinal')"
                  v-model="dDatosFechas.fechaFinVencDateString" append-icon="event" readonly
                  :rules="[rules.checkfechasVencimientos]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinFin" clearable color="datSecondary"
                  v-model="dDatosFechas.fechaFinVencDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaFinVencMenu.save(dDatosFechas.fechaFinVencDate)" type="month">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 px-3>
              <v-menu ref="fechaIniFacturaMenu" lazy :close-on-content-click="false"
                v-model="dDatosFechas.fechaIniFacturaMenu" transition="scale-transition" offset-y full-width
                :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator"
                  :label="$t('mesEjercicioComparadoIni')" v-model="dDatosFechas.fechaIniFacturaDateString"
                  append-icon="event" readonly :rules="[rules.checkfechasFacturas]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinIni" clearable color="datSecondary"
                  v-model="dDatosFechas.fechaIniFacturaDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIniFacturaMenu.save(dDatosFechas.fechaIniFacturaDate)" type="month">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 px-3>
              <v-menu ref="fechaFinFacturaMenu" lazy :close-on-content-click="false"
                v-model="dDatosFechas.fechaFinFacturaMenu" transition="scale-transition" offset-y full-width
                :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator"
                  :label="$t('mesEjercicioComparadoFin')" v-model="dDatosFechas.fechaFinFacturaDateString"
                  append-icon="event" readonly :rules="[rules.checkfechasFacturas]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinFin" clearable color="datSecondary"
                  v-model="dDatosFechas.fechaFinFacturaDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaFinFacturaMenu.save(dDatosFechas.fechaFinFacturaDate)" type="month">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-flex xs12 sm6 px-3>
            <v-select :items="dTipoRepresentante" :label="$t('tipoRepresentante')"
              v-model="dTipoRepresentanteSeleccionado" item-value="codigo" item-text="nombre"></v-select>
          </v-flex>

        </v-card-text>
        <v-card-actions class="py-3 transparent">
          <v-flex xs12 pr-3 class="text-xs-right">
            <v-btn class="datPrimaryBtnOut" flat @click="fLimpiarFiltros()">{{ $t('limpiar') }}</v-btn>
            <v-btn class="datPrimaryBtn" flat @click="fDescargarInforme()" :disabled="disableDescarga">
              {{ descargarTxt }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

// Servicios
import SrvImpresion from '@/services/srv-impresion'

import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'

export default {
  name: 'ShpFiltroBaseInformes',
  components: {
    DatTextFieldCodeSubfield,
    DatTextFieldCode
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  watch: {
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaIniVencDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaIniVencDateString = this.$moment(val, 'YYYY-MM').format('MM/YYYY')
        const fechaFacturaDate = this.dDatosFechas.fechaIniVencDateString.split('/')
        if (((parseInt(fechaFacturaDate[1]) - 1) >= this.$moment(this.dDatosFechas.fechaMinIni, this.dStringDate.years).format('YYYY') && (fechaFacturaDate[0]) >= this.$moment(this.dDatosFechas.fechaMinIni, this.dStringDate.years).format('MM')) || this.dDatosFechas.fechaMinIni === '') {
          this.dDatosFechas.fechaIniFacturaDateString = fechaFacturaDate[0] + '/' + (parseInt(fechaFacturaDate[1]) - 1)
        } else {
          this.dDatosFechas.fechaIniFacturaDateString = ''
        }
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaFinVencDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaFinVencDateString = this.$moment(val, 'YYYY-MM').format('MM/YYYY')
        const fechaFacturaDate = this.dDatosFechas.fechaFinVencDateString.split('/')
        if (((parseInt(fechaFacturaDate[1]) - 1) >= this.$moment(this.dDatosFechas.fechaMinFin, this.dStringDate.years).format('YYYY') && (fechaFacturaDate[0]) >= this.$moment(this.dDatosFechas.fechaMinFin, this.dStringDate.years).format('MM')) || this.dDatosFechas.fechaMinFin === '') {
          this.dDatosFechas.fechaFinFacturaDateString = fechaFacturaDate[0] + '/' + (parseInt(fechaFacturaDate[1]) - 1)
        } else {
          this.dDatosFechas.fechaFinFacturaDateString = ''
        }
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaIniFacturaDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaIniFacturaDateString = this.$moment(val, 'YYYY-MM').format('MM/YYYY')
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaFinFacturaDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaFinFacturaDateString = this.$moment(val, 'YYYY-MM').format('MM/YYYY')
      }
    }
  },
  data() {
    return {
      dStringDate: {
        'default': 'DD-MM-YYYY',
        'years': 'YYYY-MM-DD'
      },
      dLoading: false,
      dRowsPerPage: 5,
      descargarTxt: this.$t('descargar'),
      disableDescarga: false,
      dErrorMsgRepreIni: [],
      dRole: '',
      openComponente: true,
      informeComponente: null,
      dSelectRepre: { codigo: '', subfield: '', nombre: '' },
      dRequestRepresentante: { empresa: this.$store.getters.getAutenticacion.empresa, pasivo: 'N' },
      dRequestRepreSec: {},
      dSelectClient: { codigo: '', nombre: '' },
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa, cliente: '' },
      dTipoRepresentanteSeleccionado: 0,
      dTipoRepresentante: [
        { codigo: 0, nombre: '-', value: '' },
        { codigo: 1, nombre: this.$t('Representante'), value: 'R' },
        { codigo: 2, nombre: this.$t('cliente'), value: 'C' }
      ],
      dDataRepre: {},
      dDataClient: {},
      dDatosFechas: {
        'fechaIniVencMenu': false,
        'fechaIniVencDate': '',
        'fechaIniVencDateString': '',
        'fechaMinIni': '',
        'fechaFinVencMenu': false,
        'fechaFinVencDate': '',
        'fechaFinVencDateString': '',
        'fechaMinFin': '',
        'fechaIniFacturaMenu': false,
        'fechaIniFacturaDate': '',
        'fechaIniFacturaDateString': '',
        'fechaFinFacturaMenu': false,
        'fechaFinFacturaDate': '',
        'fechaFinfacturaDateString': ''
      },
      rules: {
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechasVencimientos: (value) => {
          if ((this.dDatosFechas.fechaIniVencDateString !== undefined) && (this.dDatosFechas.fechaFinVencDateString !== undefined) &&
            (this.dDatosFechas.fechaIniVencDateString !== null) && (this.dDatosFechas.fechaFinVencDateString !== null) &&
            (this.dDatosFechas.fechaIniVencDateString !== '') && (this.dDatosFechas.fechaFinVencDateString !== '')) {
            const fechaIniVencDate = this.$moment(this.dDatosFechas.fechaIniVencDateString, 'MM/YYYY')
            const fechaFinVencDate = this.$moment(this.dDatosFechas.fechaFinVencDateString, 'MM/YYYY')
            if (fechaIniVencDate <= fechaFinVencDate) {
              this.fValidateOtherRules()
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        },
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechasFacturas: (value) => {
          if ((this.dDatosFechas.fechaIniFacturaDateString !== undefined) && (this.dDatosFechas.fechaFinFacturaDateString !== undefined) &&
            (this.dDatosFechas.fechaIniFacturaDateString !== null) && (this.dDatosFechas.fechaFinFacturaDateString !== null) &&
            (this.dDatosFechas.fechaIniFacturaDateString !== '') && (this.dDatosFechas.fechaFinFacturaDateString !== '')) {
            const fechaIniFacturaDate = this.$moment(this.dDatosFechas.fechaIniFacturaDateString, 'MM/YYYY')
            const fechaFinFacturaDate = this.$moment(this.dDatosFechas.fechaFinFacturaDateString, 'MM/YYYY')
            if (fechaIniFacturaDate <= fechaFinFacturaDate) {
              this.fValidateOtherRules()
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        }
      }
    }
  },
  created() {
    this.fLimitFechas()

    this.fIniciarVariables()
    // Inicializa las variables locales
    this.informeComponente = this.pInformeComponente
  },
  methods: {
    fIniciarVariables() {
      let isRepre = false
      this.dRole = this.pLimitDate.roleUser
      if (this.dRole === 'REPRESENTANTE') {
        this.dSelectRepre.codigo = this.$store.getters.getAutenticacion.representante
        this.dSelectRepre.nombre = this.$store.getters.getAutenticacion.representanteNombre
        this.dSelectRepre.subfield = this.$store.getters.getAutenticacion.agente
        isRepre = true
        this.dRequestRepreSec = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          representante: this.$store.getters.getAutenticacion.representante,
          agente: this.$store.getters.getAutenticacion.agente
        }
      }

      this.dDataRepre = {
        'errorMessages': [],
        'labelMainField': 'codigo',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovRep',
        'headersSec': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'REP_REPRESENTANTE' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'REP_AGENTE' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'REP_NOMBRE' }
        ],
        'filtersSec': { 'codigo': 'REP_REPRESENTANTE', 'subfield': 'REP_AGENTE', 'nombre': 'REP_NOMBRE' },
        'defaultSec': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'isSec': isRepre,
        'urlSec': 'getRepres',
        'requestSec': this.dRequestRepreSec,
        'orderByDefaultSec': 'REP_REPRESENTANTE',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepresentante,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectRepre,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }


      if (this.pLimitDate.roleUser === 'CLIENTE' || this.pLimitDate.roleUser === 'MULTISUCURSAL') {
        this.dRequestClient.cliente = this.$store.getters.getAutenticacion.cliente;
        this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente;
      }

      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClient,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }

    },
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectRepre.codigo = item.codigo
        this.dSelectRepre.subfield = item.subfield
        this.dSelectRepre.nombre = item.nombre
      }
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClient.codigo = item.codigo
        this.dSelectClient.nombre = item.nombre
      }
    },
    fCleanRepre() {
      this.dSelectRepre = {}
    },
    fCleanClient() {
      this.dSelectClient = {}
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.fLimpiarFiltros()
      this.$emit('close')
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiarFiltros() {
      this.dErrorMsgRepreIni = []

      if (this.dRole === 'ADMIN') {
        this.dSelectRepre = { codigo: '', subfield: '', nombre: '' }
        this.dSelectClient = { codigo: '', nombre: '' }
        if (this.$refs.TableRepre) {
          this.$refs.TableRepre.fActualizarItem(this.dSelectRepre)
        }
        if (this.$refs.TableClient) {
          this.$refs.TableClient.fActualizarItem(this.dSelectClient)
        }
      }
      this.dDatosFechas.fechaIniVencMenu = false
      this.dDatosFechas.fechaIniVencDate = null
      this.dDatosFechas.fechaIniVencDateString = null

      this.dDatosFechas.fechaFinVencMenu = false
      this.dDatosFechas.fechaFinVencDate = null
      this.dDatosFechas.fechaFinVencDateString = null

      this.dDatosFechas.fechaIniFacturaMenu = false
      this.dDatosFechas.fechaIniFacturaDate = null
      this.dDatosFechas.fechaIniFacturaDateString = null

      this.dDatosFechas.fechaFinFacturaMenu = false
      this.dDatosFechas.fechaFinFacturaDate = null
      this.dDatosFechas.fechaFinFacturaDateString = null
    },
    fAssignedFilters(jsonEntrada) {
      if (((this.dSelectRepre !== undefined) && (this.dSelectRepre.codigo !== '') && (this.dSelectRepre.codigo !== undefined))) {
        jsonEntrada.representanteInicial = this.dSelectRepre.codigo
        jsonEntrada.representanteFinal = this.dSelectRepre.codigo
      }
      if (((this.dSelectClient !== undefined) && (this.dSelectClient.codigo !== '') && (this.dSelectClient.codigo !== undefined))) {
        jsonEntrada.clienteInicial = this.dSelectClient.codigo
        jsonEntrada.clienteFinal = this.dSelectClient.codigo
      }
      jsonEntrada.mesEjercicioInicial = ((this.dDatosFechas.fechaIniVencDateString !== null) && (this.dDatosFechas.fechaIniVencDateString !== '')) ? this.dDatosFechas.fechaIniVencDateString : ''
      jsonEntrada.mesEjercicioFinal = ((this.dDatosFechas.fechaFinVencDateString !== null) && (this.dDatosFechas.fechaFinVencDateString !== '')) ? this.dDatosFechas.fechaFinVencDateString : ''
      jsonEntrada.mesEjercicioComparadoInicial = ((this.dDatosFechas.fechaIniFacturaDateString !== null) && (this.dDatosFechas.fechaIniFacturaDateString !== '')) ? this.dDatosFechas.fechaIniFacturaDateString : ''
      jsonEntrada.mesEjercicioComparadoFinal = ((this.dDatosFechas.fechaFinFacturaDateString !== null) && (this.dDatosFechas.fechaFinFacturaDateString !== '')) ? this.dDatosFechas.fechaFinFacturaDateString : ''
    },
    /**
     * Metodo de descarga del informes
     */
    fDescargarInforme() {
      const ventanaPdf = abrirPestanaEnBlanco()
      this.descargarTxt = this.$t('descargar')
      this.dLoading = true
      if (this.fValidateOtherRules()) {
        this.fDescargandoInforme()
        // prepara los parametros generales de busqueda
        const jsonEntrada = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          pdfSn: 'S',
          tipoRepresentante: this.dTipoRepresentante[this.dTipoRepresentanteSeleccionado].value
        }
        this.fAssignedFilters(jsonEntrada)
        if (this.fCheckFiltrosPendientes()) {
          SrvImpresion.ventasDelegacionRepresCliente(jsonEntrada).then(response => {
            if (response.data.statusCode === '200' && response.data.result !== 'ko') {
              // obtiene la url y la levanta en una nueva ventana
              if (response.data.dataRes.report && response.data.dataRes.report !== '') {
                abrirPdfEnPestanaPreabierta(generarPdf(response.data.dataRes.report), ventanaPdf)
              } else {
                if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
                this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br/>' + this.$t('estadoVentaNotFoundDesc'))
              }
            } else {
              if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
              this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.errorMsg.code + ': ' + response.data.errorMsg.message)
            }
            this.disableDescarga = false
            this.descargarTxt = this.$t('descargar')
            this.dLoading = false
          }).catch(error => {
            if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
            this.fErrorComprobado(error.response)
            this.disableDescarga = false
            this.descargarTxt = this.$t('descargar')
            this.dLoading = false
          })
        } else {
          if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
          this.disableDescarga = false
          this.descargarTxt = this.$t('descargar')
          this.dLoading = false
          this.$emit('alert', '<b>' + this.$t('avisoFactura') + '</b><br/>' + this.$t('avisoFacturaDesc'))
        }
      } else {
        if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
        this.disableDescarga = false
        this.descargarTxt = this.$t('descargar')
        this.dLoading = false
        this.$emit('alert', '<b>' + this.$t('reviseFiltros') + '</b>')
      }
    },
    /*
     * Metodo de descargando
     */
    fDescargandoInforme() {
      this.disableDescarga = true
      this.descargarTxt = this.$t('enPreparacion')
    },
    /**
     * valida el resto de reglas
     */
    fValidateOtherRules() {
      return this.dErrorMsgRepreIni.length === 0
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      const hasRepre = this.dSelectRepre.codigo !== undefined && this.dSelectRepre.codigo !== '';
      const hasClient = this.dSelectClient.codigo !== undefined && this.dSelectClient.codigo !== '';
      return hasRepre || hasClient;
    }, 
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dDatosFechas.fechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dStringDate.years).format(this.dStringDate.years)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dDatosFechas.fechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dStringDate.years).format(this.dStringDate.years)
      }
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Estadisticas/ShpEstadisticasVentas.vue